module.exports = __webpack_public_path__ + "static/media/hands-helping.7aed10d4.svg";